export enum CalendarResourceChannel {
  CREATE = 'calendarResource::create',
  EDIT = 'calendarResource::patch',
  DELETE = 'calendarResource::delete',
}
